module.exports = __webpack_public_path__ + "img/product6.d74c37f3.png";